import React from 'react';
import AppPhonebook from '../components/ProjectPhonebook/AppPhonebook';

const Phonebook = () => {
  return <AppPhonebook />;
};

export default Phonebook;
